import script from "./Loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loading.vue?vue&type=script&setup=true&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=31be7db0&lang=scss&scoped=true"

import exportComponent from "/Users/min_zero/Desktop/haii/projects/alzguard-app-web-at/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31be7db0"]])

export default __exports__